import {
  FETCH_CTO,
  FETCH_CTO_SUCCESS,
  FETCH_CTO_FAILURE,
  ADD_CTO,
  ADD_CTO_SUCCESS,
  ADD_CTO_FAILURE,
  EDIT_CTO,
  EDIT_CTO_SUCCESS,
  EDIT_CTO_FAILURE,
  DELETE_CTO,
  DELETE_CTO_SUCCESS,
  DELETE_CTO_FAILURE,
  FETCH_CTO_DETAILS,
  FETCH_CTO_DETAILS_SUCCESS,
  FETCH_CTO_DETAILS_FAILURE,
  FETCH_PICK_UP_CTOS,
  FETCH_PICK_UP_CTOS_SUCCESS,
  FETCH_PICK_UP_CTOS_FAILURE,
  FETCH_DROP_OFF_CTOS,
  FETCH_DROP_OFF_CTOS_SUCCESS,
  FETCH_DROP_OFF_CTOS_FAILURE

} from "@utils/actionTypes";

const INIT_STATE = {
  loadingCto: false,
  ctoData: null,
  addingCto: false,
  editingCto: false,
  deletingCto: null,
  loadingCtoDetails: false,
  ctoDetailData: null,
  loadingPickUpCto: false,
  pickUpCtoData: null,
  loadingDropOffCto: false,
  dropOffCtoData: null,
};

const ctoReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CTO:
      return { ...state, loadingCto: true };
    case FETCH_CTO_SUCCESS:
      return { ...state, ctoData: action.payload, loadingCto: false };
    case FETCH_CTO_FAILURE:
      return { ...state, ctoData: action.payload, loadingCto: false };

    case ADD_CTO:
      return { ...state, addingCto: true };
    case ADD_CTO_SUCCESS:
      return {
        ...state,
        addingCto: false,
      };
    case ADD_CTO_FAILURE:
      return {
        ...state,
        addingCto: false,
      };

    case EDIT_CTO:
      return { ...state, editingCto: true };
    case EDIT_CTO_SUCCESS:
      return {
        ...state,
        editingCto: false,
      };
    case EDIT_CTO_FAILURE:
      return {
        ...state,
        editingCto: false,
      };

    case DELETE_CTO:
      return { ...state, deletingCto: true };
    case DELETE_CTO_SUCCESS:
      return {
        ...state,
        deletingCto: false,
      };
    case DELETE_CTO_FAILURE:
      return {
        ...state,
        deletingCto: false,
      };

    case FETCH_CTO_DETAILS:
      return { ...state, loadingCtoDetails: true };
    case FETCH_CTO_DETAILS_SUCCESS:
      return { ...state, ctoDetailData: action.payload, loadingCtoDetails: false };
    case FETCH_CTO_DETAILS_FAILURE:
      return { ...state, ctoDetailData: action.payload, loadingCtoDetails: false };

    case FETCH_PICK_UP_CTOS:
      return { ...state, loadingPickUpCto: true };
    case FETCH_PICK_UP_CTOS_SUCCESS:
      return { ...state, pickUpCtoData: action.payload, loadingPickUpCto: false };
    case FETCH_PICK_UP_CTOS_FAILURE:
      return { ...state, pickUpCtoData: action.payload, loadingPickUpCto: false };

    case FETCH_DROP_OFF_CTOS:
      return { ...state, loadingDropOffCto: true };
    case FETCH_DROP_OFF_CTOS_SUCCESS:
      return { ...state, dropOffCtoData: action.payload, loadingDropOffCto: false };
    case FETCH_DROP_OFF_CTOS_FAILURE:
      return { ...state, dropOffCtoData: action.payload, loadingDropOffCto: false };

    default:
      return state;
  }
};
export default ctoReducer;
